import { useMemo } from 'react';
import { useResolvedVersion } from '@client/hooks/use-resolved-version.hooks';
import { useSharedMemo } from '@client/hooks/use-utils.hooks';
import { useProject } from '@client/store/project';
import { createMarketEstimatesSnapshot } from '@shared/helpers/product-market-estimates.helpers';
import {
  buildLiveProductA1A3ByElementId,
  type LiveProductCo2,
} from './element-list-live-co2.helpers';

/**
 * Live product carbon for every element in the resolved tree.
 * Shared across list rows so each row does not walk the tree again.
 * Factors come from the baseline product copies on that version.
 * Climate percentiles use the same market-estimate snapshot as the side panel.
 */
export const useLiveProductA1A3ByElementId = (): ReadonlyMap<
  string,
  LiveProductCo2
> => {
  const version = useResolvedVersion();
  const productsMap = version?.products;
  const { marketEstimates: projectMarketEstimates } = useProject();
  const marketEstimates = useMemo(
    () => projectMarketEstimates ?? createMarketEstimatesSnapshot(),
    [projectMarketEstimates],
  );

  return useSharedMemo(
    () =>
      buildLiveProductA1A3ByElementId(version, productsMap, marketEstimates),
    'elementListLiveProductA1A3',
    [version, productsMap, marketEstimates],
  );
};
